import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

import DropdownComponent from "../../common/dropdownComponent";

const RoleSelectionModal = ({
  show,
  handleClose,
  handleSave,
  userRoles,
  userId,
  refetch,
  userDefinedRoles,
  getFirmUserType,
  userRole,
}) => {
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [hourlyRates, setHourlyRates] = useState({});

  const handleCheckboxChange = (role) => {
    setSelectedRoles((prevSelected) => {
      const current = prevSelected || [];
      return current.includes(role) ? current.filter((r) => r !== role) : [...current, role];
    });
  };

  useEffect(() => {
    if (userId) {
      const user = userDefinedRoles.find((user) => user.id === userId);

      if (user) {
        setSelectedRoles(user?.firm_roles?.[0]?.for_firm_usertype?.map((role) => role.id) || []);
        setHourlyRates(
          user?.hourly_rates?.reduce((acc, role) => {
            if (role?.for_role?.id) {
              acc[role.for_role.id] = role.rate;
            }
            return acc;
          }, {}) || {}
        );
      }
    }
  }, [userId, userDefinedRoles]);

  const handleHourlyRateChange = (roleId, rate) => {
    setHourlyRates((prevRates) => ({
      ...prevRates,
      [roleId]: rate,
    }));
  };

  const handleSaveRoles = async () => {
    const payload = userRoles.reduce((acc, role) => {
      acc[role.id] = selectedRoles?.includes(role.id);

      acc[`hourly_rate_${role.id}`] = selectedRoles?.includes(role.id)
        ? parseFloat(hourlyRates[role.id]) || 0.0
        : 0.0;

      return acc;
    }, {});

    payload.user_id = userId;

    await handleSave(payload);
    refetch();
    handleClose();
    setSelectedRoles([]);
    setHourlyRates({});
  };

  return (
    <Modal
      show={show}
      dialogClassName="max-700p modal-dialog-centered "
      contentClassName="custom-modal-new-provider"
      onHide={handleClose}
      centered
    >
      <Modal.Header
        style={{
          borderBottom: "0px",
        }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="modal_title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          Check the boxes of all the roles this Firm User can hold in the firm
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className=""
        style={{
          padding: "5px 10px 5px 10px",
        }}
      >
        <div className="d-flex align-items-center justify-content-between w-100 m-b-5">
          <div className="ms-4 text-nowrap font-weight-600">Default User Role</div>
          <div style={{ flexBasis: "45%" }}>
            <DropdownComponent
              className=""
              getFirmUserType={
                getFirmUserType?.filter((role) => selectedRoles?.includes(role.id)) ?? []
              }
              getUserRoles={userRole}
            />
          </div>
        </div>
        <Form>
          {userRoles?.map((role) => (
            <div
              key={role.id}
              className="d-flex justify-content-between align-items-center m-b-5"
              style={{ width: "100%" }}
            >
              <div className="d-flex align-items-center" style={{ flexBasis: "50%" }}>
                <input
                  type="checkbox"
                  checked={selectedRoles?.includes(role.id)}
                  onChange={() => handleCheckboxChange(role.id)}
                  style={{
                    width: "13px",
                    minWidth: "13px",
                    height: "13px",
                    minHeight: "13px",
                    marginRight: "5px",
                    flexShrink: 0,
                  }}
                />
                <span>{role.name}</span>
              </div>
              <div style={{ flexBasis: "45%" }}>
                <Form.Control
                  type="text"
                  placeholder="Enter Hourly Rate"
                  value={hourlyRates[role.id] || ""}
                  onChange={(e) => handleHourlyRateChange(role.id, e.target.value)}
                  disabled={!selectedRoles?.includes(role.id)}
                  className="height-25 py-0"
                />
              </div>
            </div>
          ))}
        </Form>
        <div
          className="d-flex align-items-center justify-content-between p-0 mt-0 "
          style={{ borderTop: "none" }}
        >
          <Button
            variant="secondary"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
            style={{ padding: "0px 12px" }}
            onClick={handleClose}
          >
            Close
          </Button>

          <Button
            type="submit"
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center "
            style={{ padding: "0px 12px" }}
            onClick={handleSaveRoles}
          >
            Save and Close
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RoleSelectionModal;
